import React from "react";

import { FiMic, FiMicOff } from "react-icons/fi";

import { useLocalAudioToggle, useVideoContext } from "hooks/session";
import { IconButton, Switch } from "@chakra-ui/react";

interface Props {
  disabled?: boolean;
  isSwitch?: boolean;
}

const ToggleAudioButton: React.FC<Props> = ({ disabled, isSwitch }: Props) => {
  const [isAudioEnabled, toggleAudioEnabled] = useLocalAudioToggle();
  const { localTracks } = useVideoContext();
  const hasAudioTrack = localTracks.some(track => track.kind === "audio");

  return (
    <>
      {isSwitch ? (
        <Switch
          aria-label="Toggle Video"
          isChecked={isAudioEnabled}
          disabled={!hasAudioTrack || disabled}
          onChange={toggleAudioEnabled}
          data-cy-audio-toggle
        />
      ) : (
        <IconButton
          aria-label="Toggle Audio"
          onClick={toggleAudioEnabled}
          disabled={!hasAudioTrack || disabled}
          icon={isAudioEnabled ? <FiMic /> : <FiMicOff />}
          data-cy-audio-toggle
        />
      )}
    </>
  );
};

export default ToggleAudioButton;
